import { Capacitor } from '@capacitor/core';

/**
 * 設備服務工具類
 * 統一管理平台相關的環境判斷
 */
export class DeviceService {
  /**
   * 判斷是否為原生 APP（iOS/Android）
   */
  public static isNative(): boolean {
    return Capacitor.isNativePlatform();
  }

  /**
   * 判斷是否為 Web 環境
   */
  public static isWeb(): boolean {
    return !this.isNative();
  }

  /**
   * 獲取當前平台
   */
  public static getPlatform(): 'web' | 'ios' | 'android' {
    if (this.isWeb()) {
      return 'web';
    }
    
    const platform = Capacitor.getPlatform();
    if (platform === 'ios') {
      return 'ios';
    } else if (platform === 'android') {
      return 'android';
    }
    
    return 'web';
  }

  /**
   * 獲取設備信息
   */
  public static getDeviceInfo() {
    const platform = this.getPlatform();
    const userAgent = navigator.userAgent;
    
    return {
      platform,
      userAgent,
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent),
      isTablet: /iPad|Android(?=.*\bMobile\b)(?=.*\bSafari\b)/i.test(userAgent),
      isDesktop: !(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)),
    };
  }

  /**
   * 獲取設備唯一標識
   */
  public static async getUniqueId(): Promise<string> {
    if (this.isNative()) {
      // 在原生環境中，可以通過 Capacitor 插件獲取設備唯一標識
      // 這裡暫時返回一個隨機生成的 ID
      return this.generateUniqueId();
    }
    
    // Web 環境中，嘗試從 localStorage 獲取或生成新的 ID
    let uniqueId = localStorage.getItem('deviceUniqueId');
    if (!uniqueId) {
      uniqueId = this.generateUniqueId();
      localStorage.setItem('deviceUniqueId', uniqueId);
    }
    
    return uniqueId;
  }

  /**
   * 生成唯一標識
   */
  private static generateUniqueId(): string {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  }
}

// 導出單例實例
export const deviceService = DeviceService;
